const isDevelopment = process.env.NODE_ENV === "development";
const defaultPublicApiBaseUrl = isDevelopment ? "http://localhost:3000" : "https://api.dragaocareca.com";
const publicApiBaseUrl = process.env.REACT_APP_PUBLIC_API_BASE_URL || defaultPublicApiBaseUrl;

const defaults = {
    maxEpisodesPerPage: 10,
};

const config = {
    isDevelopment,
    publicApiBaseUrl,
    defaults,
    maxEpisodesPerPage: defaults.maxEpisodesPerPage,
};

export default config;
